import React from 'react';

import Button from '@atlaskit/button';
import type { TriggerProps } from '@atlaskit/popup';

import { Emoji } from '@qality/common-components/src/atoms/Emoji';

import { useFeedbackDispatch, useFeedbackState } from '../Feedback.reducer';
import { useFeedbackVisibility } from '../FeedbackVisibilityProvider';

type Props = {
  triggerProps: TriggerProps;
};

export default function Trigger({ triggerProps }: Props): JSX.Element {
  const dispatch = useFeedbackDispatch();
  const state = useFeedbackState();
  const { hideShareFeedback } = useFeedbackVisibility();

  const handleTriggerClick = () => {
    // Hide feedback if user has closed the popup on any screen
    // after the 'choose-emoji-screen'
    const { name } = state.screen;
    if (name !== 'choose-emoji-screen' && name !== 'popup-closed') {
      hideShareFeedback();
    }

    dispatch({ type: 'toggle-popup' });
  };

  return (
    <Button {...triggerProps} onClick={handleTriggerClick}>
      <Emoji emoji='😍' label='Smiling Face with Heart-Eyes' /> Share feedback
    </Button>
  );
}
